import React from 'react';

/**
 * Renders the amp markup for the component. We DO not use the arrow style so that we can have access to this.
 * Known issue with Facebook embeds being responsive: https://github.com/ampproject/amphtml/issues/10939#issuecomment-504292754
 */
function renderAmp() {
  const {
    type,
    url,
  } = this.props; // eslint-disable-line

  // Bail out if type and url are empty.
  if (!type || !url) {
    return false;
  }

  // set platform to lowercase
  const platform = type.toLowerCase();

  // Grab the twitter id if any
  let twitterId = null;
  if (platform === 'twitter') {
    const twitterUrl = new URL(url);
    if (twitterUrl.pathname) {
      const pathArray = twitterUrl.pathname.split('/');
      twitterId = pathArray[pathArray.length - 1];
    }
  }

  let instagramShortcode = null;
  if (platform === 'instagram') {
    const instagramUrl = new URL(url);
    if (instagramUrl.pathname) {
      const instagramPathArray = instagramUrl.pathname.split('/');
      instagramShortcode = instagramPathArray ? instagramPathArray[2] : null;
    }
  }

  return (
    <>
      {platform === 'facebook' && (
        <amp-facebook
          width="250"
          height="303"
          layout="responsive"
          data-href={url}
        />
      )}

      {platform === 'twitter' && twitterId && (
        <amp-twitter
          width="250"
          height="472"
          layout="responsive"
          data-tweetid={twitterId}
        />
      )}

      {platform === 'instagram' && instagramShortcode && (
        <amp-instagram
          data-shortcode={instagramShortcode}
          data-captioned
          width="1"
          height="1"
          layout="responsive"
        />
      )}

      {platform === 'ex.co' && (
        <amp-playbuzz
          src={url}
          height="520"
        />
      )}
    </>
  );
}

export default renderAmp;
